import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, User, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

export const Navbar = () => {
  const { count } = useCart();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const links = [
    { to: "/shop", label: "Shop All" },
    { to: "/shop?category=punk", label: "Punk" },
    { to: "/shop?category=sports", label: "Sports" },
    { to: "/shop?category=fitness", label: "Fitness" },
    { to: "/shop?category=street", label: "Street Gear" },
    { to: "/shop?type=print", label: "Prints" },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-card border-b-2 border-border" data-testid="navbar">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8 flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-logo" className="flex items-center hover:opacity-80 transition-opacity">
          <img src="/logo.png" alt="Unlimited Gear" className="h-10 md:h-11 w-auto" />
        </Link>

        <div className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-outfit font-bold uppercase text-sm tracking-wide hover:text-primary transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-4">
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin" className="hidden md:block font-outfit font-bold uppercase text-xs border-2 border-border px-3 py-1.5 hover:bg-secondary hover:border-secondary hover:text-white hover:text-white transition-colors">
              Admin
            </Link>
          )}
          {user ? (
            <Link to="/account" data-testid="nav-account" className="flex items-center gap-2 font-outfit font-bold uppercase text-xs border-2 border-border px-3 py-1.5 hover:bg-primary hover:text-black hover:border-primary transition-colors">
              <User strokeWidth={2} size={18} /> <span className="hidden sm:inline">Account</span>
            </Link>
          ) : (
            <Link to="/login" data-testid="nav-login" className="flex items-center gap-2 font-outfit font-bold uppercase text-xs border-2 border-primary bg-primary text-primary-foreground px-3 py-1.5 hover:bg-secondary hover:text-white hover:border-secondary transition-colors">
              <User strokeWidth={2} size={18} /> Log In
            </Link>
          )}
          <Link to="/cart" data-testid="nav-cart" className="relative hover:text-primary transition-colors">
            <ShoppingCart strokeWidth={2} size={22} />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-2 -right-2 bg-primary text-primary-foreground text-[10px] font-bold w-5 h-5 flex items-center justify-center">
                {count}
              </span>
            )}
          </Link>
          <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t-2 border-border bg-card px-5 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          {links.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="font-outfit font-bold uppercase text-sm">
              {l.label}
            </Link>
          ))}
          {user && user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="font-outfit font-bold uppercase text-sm">Admin</Link>}
          {!user && (
            <Link to="/login" onClick={() => setOpen(false)} data-testid="mobile-login" className="font-outfit font-bold uppercase text-sm text-primary">Log In / Sign Up</Link>
          )}
          {user && (
            <button onClick={() => { logout(); setOpen(false); nav("/"); }} data-testid="nav-logout" className="text-left font-outfit font-bold uppercase text-sm text-primary">
              Log Out
            </button>
          )}
        </div>
      )}
    </nav>
  );
};
